import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  selector: '[nebulaNever]'
})
export class NebulaNeverDirective implements ControlValueAccessor {
  onChangeCallback = (_: any) => { };
  onTouchedCallback = () => { };
  constructor(
    private _renderer: Renderer2,
    private _elementRef: ElementRef,
    private control: NgControl,
    private translate: TranslateService
  ) {
    setTimeout(() => {
      this._renderer.setProperty(
        this._elementRef.nativeElement,
        'value',
        this._elementRef.nativeElement.value || this.translate.instant('Common_Never')
      );
      this.control.valueChanges.subscribe(() => {
        this._setNeverValue();
      });
      this.control.control.updateValueAndValidity();
    });
  }

  @HostListener('blur') onBlur() {
    this._setNeverValue();
  }

  writeValue(value: any) {
    this._setNeverValue();
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  private _setNeverValue() {
    if (this.control.value === null && this.control.valid) {
      setTimeout(() => {
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', this.translate.instant('Common_Never'));
      });
    }
  }
}
